// extracted by mini-css-extract-plugin
export default {"mainContainer":"ExpensesPage_mainContainer__Y19Fn","pageContainer":"ExpensesPage_pageContainer__rLhxx"};